import { useQuizStatus } from "../../../../hooks/api/quizStatus";
import { DefaultFetchError } from "../../../../hooks/fetch";

export const useQuizStatuses = () => {
    const quizStatus = useQuizStatus();

    const getQuizStatus = (subCategoryId: string) => {
        quizStatus.fetch(undefined, `${subCategoryId}/quiz-status`)
            .catch((error: DefaultFetchError) => {
                console.error('Error fetching tip:', error);
            });
    }

    return {
        getQuizStatus,
        response: quizStatus.response,
        loading: quizStatus.loading,
        error: quizStatus.error,
    };
}
